// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Join row: which banks a notification covers.
 *
 * Composite PK (notification_id, bank_id) in `PostgreSQL`, mirroring
 * `NotificationUser`. One rule can now watch several banks — "any fault, on
 * any of these three banks" is a single rule rather than one per bank.
 *
 * Delivery throttling is keyed by (notification, bank) rather than by
 * notification alone, so one bank's event cannot consume the cooldown window
 * and silently suppress the others.
 */
export class NotificationBank implements flatbuffers.IUnpackableObject<NotificationBankT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NotificationBank {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNotificationBank(
    bb: flatbuffers.ByteBuffer,
    obj?: NotificationBank,
  ): NotificationBank {
    return (obj || new NotificationBank()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNotificationBank(
    bb: flatbuffers.ByteBuffer,
    obj?: NotificationBank,
  ): NotificationBank {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NotificationBank()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  notificationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startNotificationBank(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addNotificationId(builder: flatbuffers.Builder, notificationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, notificationIdOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bankIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, updatedAtOffset, 0);
  }

  static endNotificationBank(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // notification_id
    builder.requiredField(offset, 6); // bank_id
    builder.requiredField(offset, 8); // organization_id
    return offset;
  }

  unpack(): NotificationBankT {
    return new NotificationBankT(
      this.notificationId() !== null ? this.notificationId()!.unpack() : null,
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.createdAt(),
      this.updatedAt(),
    );
  }

  unpackTo(_o: NotificationBankT): void {
    _o.notificationId = this.notificationId() !== null ? this.notificationId()!.unpack() : null;
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
  }

  unpackFields(...fields: string[]): NotificationBankT {
    const t = new NotificationBankT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("notification_id")) {
      t.notificationId = this.notificationId() !== null ? this.notificationId()!.unpack() : null;
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    return t;
  }
}

export class NotificationBankT implements flatbuffers.IGeneratedObject {
  constructor(
    public notificationId: UuidT | null = null,
    public bankId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.notificationId === null || this.notificationId === undefined) {
      throw new Error('Required field "notification_id" is not set');
    }
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    const notificationId = this.notificationId !== null ? this.notificationId!.pack(builder) : 0;
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;

    NotificationBank.startNotificationBank(builder);
    NotificationBank.addNotificationId(builder, notificationId);
    NotificationBank.addBankId(builder, bankId);
    NotificationBank.addOrganizationId(builder, organizationId);
    NotificationBank.addCreatedAt(builder, createdAt);
    NotificationBank.addUpdatedAt(builder, updatedAt);

    return NotificationBank.endNotificationBank(builder);
  }

  clone(): NotificationBankT {
    const obj = new NotificationBankT();
    obj.notificationId = this.notificationId !== null ? this.notificationId!.clone() : null;
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    return obj;
  }

  equals(other: NotificationBankT): boolean {
    if (this.notificationId !== null && other.notificationId !== null) {
      if (!this.notificationId!.equals(other.notificationId!)) return false;
    } else if (this.notificationId !== other.notificationId) return false;
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    return true;
  }
}

export function verifyNotificationBank(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "notification_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "bank_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "organization_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
